<a
  appHoverStyle
  class="sub-banner p-3"
  [routerLink]="['/', 'products', 'category', bannerData.categoryId]"
  [queryParams]="queryParams"
>
  <img loading="lazy" class="sub-banner__image" [src]="bannerData.bannerSource" />
</a>
